import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if(hash.includes('#')) return;
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollTop;